import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';//使用
import 'animate.css';
Vue.use(Element);
new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
